import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
} from '@angular/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import {
  faCircleCheck,
  faCirclePlay,
  faMedal,
  IconDefinition,
} from '@fortawesome/pro-solid-svg-icons';
import { faCirclePlay as faCirclePlayRegular } from '@fortawesome/pro-regular-svg-icons';
import {
  AccordionItemComponent,
  ProgressDonutComponent,
  SkeletonTextComponent,
} from '@lyceo/shared/ui';
import { CdkAccordion } from '@angular/cdk/accordion';
import {
  ChapterWithProgress,
  Paragraph,
} from '@lyceo/lyceo-pupil-app/practise/util-models';

@Component({
  selector: 'lyceo-toc-accordion',
  templateUrl: './toc-accordion.component.html',
  styleUrls: ['./toc-accordion.component.scss'],
  imports: [
    FaIconComponent,
    ProgressDonutComponent,
    SkeletonTextComponent,
    AccordionItemComponent,
    CdkAccordion,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TocAccordionComponent {
  public readonly chapters: InputSignal<ChapterWithProgress[] | undefined> =
    input<ChapterWithProgress[] | undefined>();
  public readonly showProgress: InputSignal<boolean | null> = input<
    boolean | null
  >(false);
  public readonly finalExam: InputSignal<boolean | null> = input<
    boolean | null
  >(false);
  public readonly chapterId: InputSignal<string | undefined> = input<
    string | undefined
  >();
  public readonly paragraphId: InputSignal<string | undefined> = input<
    string | undefined
  >();
  public readonly loading: InputSignal<boolean | null> = input<boolean | null>(
    false,
  );

  public readonly finalExamClicked: OutputEmitterRef<void> = output();
  public readonly paragraphClickedEvent: OutputEmitterRef<Paragraph> = output();

  public readonly faCircleCheck: IconDefinition = faCircleCheck;
  public readonly faCirclePlay: IconDefinition = faCirclePlay;
  public readonly faCirclePlayRegular: IconDefinition = faCirclePlayRegular;
  public readonly faMedal: IconDefinition = faMedal;

  public paragraphClicked(paragraph: Paragraph): void {
    this.paragraphClickedEvent.emit(paragraph);
  }
}
